/**
 * @file
 * Patria box highlights module functionality.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.box_highlights = {
    attach: () => {

      // Register the ScrollTrigger plugin with GSAP.
      gsap.registerPlugin(ScrollTrigger);

      // Check if box highlights exist on the page.
      if ($('.paragraph--type--module-box-highlights').length === 0) {
        return;
      }

      const boxHighlights = gsap.utils.toArray('.paragraph--type--module-box-highlights');
      boxHighlights.forEach(boxHighlight => {
        // Add timeline animation for the box highlights.
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: boxHighlight,
            pin: true,
            scrub: true,
            start: 'top top',
            end: 'bottom 150px',
          }
        });

        // For each boxItem, create a timeline animation.
        const boxItems = boxHighlight.querySelectorAll('.field--name-field-box-highlights>.field__item');
        boxItems.forEach((boxItem, index) => {
          tl.from(boxItem, {opacity: 0, yPercent: 100}, 'box' + index)
            .to(boxItem, {opacity: 1, yPercent: 0}, 'box' + index);
        });
      });
    }
  };

})(jQuery, Drupal);
